// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3Yy0X","emails":"CreateEditClinics_emails__1mNzE","emailTagLabel":"CreateEditClinics_emailTagLabel__39qXp"};